"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiPopover = require("@tencent/spaui-popover");

var _uploader = _interopRequireDefault(require("./uploader"));

var _mask_content_component = _interopRequireDefault(require("./component/imageuploader/mask_content_component"));

var _add_component = _interopRequireDefault(require("./component/imageuploader/add_component"));

var _empty_component = _interopRequireDefault(require("./component/imageuploader/empty_component"));

var _no_value_component = _interopRequireDefault(require("./component/imageuploader/no_value_component"));

var _img_content_component = _interopRequireDefault(require("./component/imageuploader/img_content_component"));

var _img_sort_component = _interopRequireDefault(require("./component/imageuploader/img_sort_component"));

var _img_component = _interopRequireDefault(require("./component/imageuploader/img_component"));

var _display_component = _interopRequireDefault(require("./component/imageuploader/display_component"));

var _index = require("./utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isFunction = _spauiUtils.utils.isFunction,
    getVersion = _spauiUtils.utils.getVersion;
var ieVersion = getVersion();
var useFileAPI = ieVersion <= -1 || ieVersion >= 10;

var ValueRenderComponent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ValueRenderComponent, _PureComponent);

  function ValueRenderComponent(props) {
    var _this;

    _classCallCheck(this, ValueRenderComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ValueRenderComponent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleComplete", function (resp, imageIndex, data, fileTarget, fileId, err, xhr) {
      if (isFunction(_this.props.handleComplete)) {
        _this.props.handleComplete(err, xhr, resp, fileTarget, fileId, imageIndex);
      }
    });

    _this.dataMap = {};
    return _this;
  }

  _createClass(ValueRenderComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.dataMap = null;
    }
  }, {
    key: "getCacheData",
    value: function getCacheData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var result = data;
      var keys = [];
      var cacheKey = '';
      var cacheData = {};
      var isEqual = false;

      if (_typeof(data) === 'object' && data) {
        keys = Object.keys(data);

        if (keys.length > 0) {
          cacheKey = "".concat(index, "-").concat(keys.join('-'));
          cacheData = this.dataMap[cacheKey] || null;

          if (cacheData) {
            isEqual = true;
            keys.forEach(function (key) {
              if (data[key] != cacheData[key]) {
                isEqual = false;
              }
            });

            if (isEqual) {
              result = cacheData;
            }
          }

          if (!isEqual) {
            this.dataMap[cacheKey] = data;
          }
        }
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? [] : _this$props$value,
          count = _this$props.count,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          drag = _this$props.drag,
          ItemAppendComponent = _this$props.ItemAppendComponent,
          ImgComponent = _this$props.ImgComponent,
          ImgContentComponent = _this$props.ImgContentComponent,
          ImgSortComponent = _this$props.ImgSortComponent,
          controls = _this$props.controls,
          reupload = _this$props.reupload,
          MaskContentComponent = _this$props.MaskContentComponent,
          required = _this$props.required,
          upload = _this$props.upload,
          type = _this$props.type,
          DisplayComponent = _this$props.DisplayComponent,
          _this$props$useNewUI = _this$props.useNewUI,
          useNewUI = _this$props$useNewUI === void 0 ? false : _this$props$useNewUI,
          _this$props$addCompon = _this$props.addComponentPosition,
          addComponentPosition = _this$props$addCompon === void 0 ? '' : _this$props$addCompon,
          _this$props$uploading = _this$props.uploadingValue,
          uploadingValue = _this$props$uploading === void 0 ? [] : _this$props$uploading,
          setUploader = _this$props.setUploader,
          genAddButton = _this$props.genAddButton,
          handleDelete = _this$props.handleDelete,
          handleSort = _this$props.handleSort,
          handleHover = _this$props.handleHover,
          ReactDnD = _this$props.ReactDnD,
          sortDragItemClassName = _this$props.sortDragItemClassName,
          sortDragItemStyle = _this$props.sortDragItemStyle;
      var imgsClassName = (0, _classnames["default"])('imgs', {
        'imgs-more': count > 1
      });
      var showValue = [];
      var result = [];
      var resultElement = null;
      var valueRenderDom = null;
      var canAdd = false;
      value.map(function (item) {
        if (item) {
          showValue.push(_objectSpread({}, item));
        }

        return item;
      });
      uploadingValue.map(function (item) {
        if (item) {
          showValue.push(_objectSpread({}, item, {
            status: 'uploading'
          }));
        }

        return item;
      });

      if (count < 2) {
        result = [showValue[0]];
      } else {
        result = showValue;
      } // 有数量限制


      if (result.length > count) {
        if (isFunction(onChange)) {
          onChange({}, result.slice(0, count));
          return false;
        }
      }

      canAdd = !disabled && count > 1 && showValue.length < count;
      resultElement = result.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var canDelete = !(typeof item["delete"] !== 'undefined' && !item["delete"]) && !disabled;
        var canReupload = reupload || false;
        var _item$popover = item.popover,
            popover = _item$popover === void 0 ? '' : _item$popover;

        if (typeof item.reupload !== 'undefined') {
          canReupload = item.reupload || false;
        }

        var child = _react["default"].createElement(ImgComponent, {
          useNewUI: useNewUI,
          onComplete: _this2.handleComplete,
          useFileAPI: useFileAPI,
          setUploader: setUploader,
          index: index,
          data: _this2.getCacheData(item, index),
          canDelete: canDelete,
          canReupload: canReupload,
          controls: controls,
          required: required,
          upload: upload,
          drag: drag,
          disabled: disabled,
          onDelete: handleDelete,
          ItemAppendComponent: ItemAppendComponent,
          ImgContentComponent: ImgContentComponent,
          ImgSortComponent: ImgSortComponent,
          DisplayComponent: DisplayComponent,
          MaskContentComponent: MaskContentComponent,
          type: type,
          onSort: handleSort,
          onHover: handleHover,
          ReactDnD: ReactDnD,
          sortDragItemClassName: sortDragItemClassName,
          sortDragItemStyle: sortDragItemStyle
        });

        var itemResult = null;
        var _popover = null;

        if (popover) {
          if (typeof popover === 'string') {
            _popover = _react["default"].createElement(_spauiPopover.PopOver, null, popover);
          } else {
            _popover = popover;
          }

          itemResult = _react["default"].createElement(_spauiPopover.OverlayTrigger, {
            key: index,
            trigger: "hover",
            placement: "top",
            overlay: _popover,
            hideDelayTime: 0
          }, child);
        } else {
          itemResult = (0, _react.cloneElement)(child, {
            key: index
          });
        }

        return itemResult;
      });
      var addButton = canAdd ? genAddButton() : null;

      if (useNewUI) {
        // 使用useNewUI 必须有React.Fragment
        if (_react["default"] && _react["default"].Fragment) {
          valueRenderDom = _react["default"].createElement(_react["default"].Fragment, null, addComponentPosition === 'forward' ? addButton : null, resultElement, addComponentPosition !== 'forward' ? addButton : null);
        }
      } else {
        valueRenderDom = _react["default"].createElement("div", {
          className: "uper uped"
        }, _react["default"].createElement("div", {
          className: "imgarea"
        }, _react["default"].createElement("ul", {
          className: imgsClassName
        }, addComponentPosition === 'forward' ? addButton : null, resultElement, addComponentPosition !== 'forward' ? addButton : null)));
      }

      return valueRenderDom;
    }
  }]);

  return ValueRenderComponent;
}(_react.PureComponent);
/**
 * @class
 */


var ImageUploader =
/*#__PURE__*/
function (_PureComponent2) {
  _inherits(ImageUploader, _PureComponent2);

  /**
   * 属性说明
   * @alias ImageUploaderProps
   * @description 图片上传组件
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {bool} [upload=true] 是否能够上传
   * @property {bool} [reupload=true] 是否支持重新上传
   * @property {bool} [required=false] 开启这个之后，将没有删除按钮
   * @property {string} [fileId] 指定"input type=file"的id
   * @property {bool} [autoUpload=true] 是否自动上传
   * @property {bool} [disabled=false] 是否禁用
   * @property {bool} [multiple=false] 是否多选
   * @property {bool} [drag=true] 是否支持拖拽
   * @property {string} [dragOverClassName=''] 拖动到区域添加的className(可用于拖动效果的样式处理)
   * @property {string} [sortDragItemClassName] 图片排序时对应拖动图片添加的className(开启图片拖动排序时才有效果)
   * @property {object} [sortDragItemStyle] 图片排序时对应拖动图片添加的style(开启图片拖动排序时才有效果)
   * @property {string} [sortHoverItemClassName] 图片排序时对应hover图片添加的className(开启图片拖动排序时才有效果)
   * @property {bool} [click=true] 是否支持点击上传
   * @property {string} [accept='*'] 选择的文件类型
   * @property {func} [onFileChange] 文件变化即调用<br />onFileChange(event, isDrag, imageIndex, files)
   * @property {titleline} 已上传数据属性
   * @property {string} [type=''] 上传类型,type=video为上传的是视频，其他为图片
   * @property {array} [value=[]] 已经上传的数据
   * @property {array} [uploadingValue=[]] 正在上传中的数据
   * @property {func} [onChange] 数据变更回调<br />onChange(event, value)
   * @property {func} [onDelete] 数据删除回调<br />onDelete(event, data)
   * @property {titleline} 触发上传属性
   * @property {string} [name=''] 字段名
   * @property {string} [url=''] 上传的url
   * @property {func} [setUrl] 动态设置上传的url
   * @property {object|function} [data={}] 接口附带的数据
   * @property {object} [headers={}] 请求header参数
   * @property {number} [uploadPoolSize] 并发上传池大小。
   * @property {func} [filter] 筛选文件（只适用于支持html5的）<br />filter(fileInfo, event)
   * @property {func} [check] 异步文件检查成功后，调用next继续上传<br />check(fileInfo, next, files) 检查成功后，调用next继续上传
   * @property {func} [canUpload] 是否能够触发上传<br />canUpload(event)
   * @property {func} [onUpload] 开始上传回调<br />onUpload(event, fileInfo)
   * @property {func} [onProgress] 上传过程回调<br />onProgress(progressEvent, fileInfo)
   * @property {func} [onComplete] 上传完成回调<br />onComplete(resp, fileInfo, inputFileId, xhr, imageIndex)
   * @property {titleline} 自定义属性
   * @property {string} [addComponentPosition='backward'] 添加组件的位置（默认为展示内容后边）,可选值：forward, backward
   * @property {func|element} [ItemAppendComponent] 附加组件结构*(具体参数看案例)*
   * @property {func|element} [AddComponent] 添加图片结构*(具体参数看案例)*
   * @property {func|element} [ImgComponent] 图片结构*(具体参数看案例)*
   * @property {func|element} [ImgContentComponent] 内容结构*(具体参数看案例)*
   * @property {func|element} [ImgSortComponent] 拖动结构
   * @property {func|element} [DisplayComponent] 展示Component*(具体参数看案例)*
   * @property {func|element} [EmptyComponent] 没有图片的结构*(具体参数看案例)*
   * @property {func|element} [MaskContentComponent] 遮罩层内容结构*(具体参数看案例)*
   * @property {func|element} [AdditionalComponent] 附加结构
   * @example
   * &lt;ItemAppendComponent
   data={data}
  /&gt;
   *
   * &lt;AddComponent /&gt;
   *
   * &lt;ImgComponent
  onComplete={imageOnComplete}
  useFileAPI={useFileAPI}
  setUploader={this.setUploader}
  index={index}
  data={item}
  canDelete={canDelete}
  canReupload={canReupload}
  controls={controls}
  required={required}
  upload={upload}
  onDelete={(event) => {}}
  ItemAppendComponent={ItemAppendComponent}
  ImgContentComponent={ImgContentComponent}
  DisplayComponent={DisplayComponent}
  MaskContentComponent={MaskContentComponent}
  type={type}
  /&gt;
   *
   * &lt;ImgContentComponent
      useFileAPI={useFileAPI}
      type={type}
      upload={upload}
      className={className)}
      data={data}
      canDelete={canDelete}
      required={required}
      onDelete={onDelete}
      controls={controls}
      DisplayComponent={DisplayComponent}
      ItemAppendComponent={ItemAppendComponent}
      MaskContentComponent={MaskContentComponent}
  /&gt;
   *
   * &lt;DisplayComponent
      type={type}
      data={data}
      controls={controls}
  /&gt;
   *
   *&lt;EmptyComponent
      useFileAPI={useFileAPI}
      drag={drag}
  /&gt;
   *
   * &lt;MaskContentComponent
      type={type}
      upload={upload}
      useFileAPI={useFileAPI}
      onDelete={onDelete}
      data={data}
      canDelete={canDelete}
  /&gt;
   *
   */
  function ImageUploader(props) {
    var _this3;

    _classCallCheck(this, ImageUploader);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ImageUploader).call(this, props));

    _defineProperty(_assertThisInitialized(_this3), "genAddButton", function () {
      var _this3$props = _this3.props,
          AddComponent = _this3$props.AddComponent,
          _this3$props$useNewUI = _this3$props.useNewUI,
          useNewUI = _this3$props$useNewUI === void 0 ? false : _this3$props$useNewUI;
      var child = null;
      var result = null;

      if (typeof AddComponent !== 'undefined') {
        child = _react["default"].createElement(AddComponent, {
          useNewUI: useNewUI
        });
        result = _this3.setUploader(child, {
          drag: false
        });
      }

      return result;
    });

    _defineProperty(_assertThisInitialized(_this3), "handleSort", function (dragIndex, hoverIndex) {
      var _this3$props2 = _this3.props,
          value = _this3$props2.value,
          onChange = _this3$props2.onChange;
      var cloneValue = [];
      var dragItem = '';

      if ((0, _spauiUtils.isArray)(value) && value.length > 1 && typeof dragIndex === 'number' && typeof hoverIndex === 'number') {
        cloneValue = (0, _spauiUtils.cloneArray)(value);
        dragItem = cloneValue[dragIndex];
        cloneValue.splice(dragIndex, 1);
        cloneValue.splice(hoverIndex, 0, dragItem);

        if (isFunction(onChange)) {
          onChange({}, cloneValue);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this3), "handleHover", function (dragIndex, hoverIndex) {
      var sortHoverItemClassName = _this3.props.sortHoverItemClassName;

      if (_this3.domRef && sortHoverItemClassName) {
        var items = _this3.domRef.getElementsByTagName('li');

        var len = items.length;
        var i = 0;

        if (len > 0) {
          for (; i < len; i++) {
            var item = items[i];

            if (item) {
              (0, _spauiUtils.removeClassName)(item, sortHoverItemClassName);

              if (item && item.getAttribute('data-index') == hoverIndex) {
                (0, _spauiUtils.addClassName)(item, sortHoverItemClassName);
              }
            }
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this3), "handleDrop", function (event) {
      var onDrop = _this3.props.onDrop;

      if (_this3.needStopPropagationDropEvent()) {
        event.preventDefault();
      }

      if (isFunction(onDrop)) {
        onDrop(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this3), "handleDragOver", function (event) {
      var onDragOver = _this3.props.onDragOver;

      if (_this3.needStopPropagationDropEvent()) {
        event.preventDefault();
      }

      if (isFunction(onDragOver)) {
        onDragOver(event);
      }
    });

    _this3.refList();

    _this3.instanceId = "".concat((0, _index.uniqueId)(), "-imageuploader");
    _this3.handleDelete = _this3.handleDelete.bind(_assertThisInitialized(_this3));
    _this3.handleComplete = _this3.handleComplete.bind(_assertThisInitialized(_this3));
    _this3.setUploader = _this3.setUploader.bind(_assertThisInitialized(_this3));
    _this3.handleProgress = _this3.handleProgress.bind(_assertThisInitialized(_this3));
    _this3.state = {
      uploadingValue: props.uploadingValue || []
    };
    return _this3;
  }

  _createClass(ImageUploader, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (typeof nextProps.uploadingValue !== 'undefined') {
        this.setState({
          uploadingValue: nextProps.uploadingValue || []
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.refList();
    }
  }, {
    key: "refList",
    value: function refList() {
      this.domRef = null;
      this.uploadRef = null;
    } // 进度

  }, {
    key: "handleProgress",
    value: function handleProgress(event, fileTarget, fileId) {
      var _this$props2 = this.props,
          onProgress = _this$props2.onProgress,
          propsUploadingValue = _this$props2.uploadingValue;
      var _this$state$uploading = this.state.uploadingValue,
          uploadingValue = _this$state$uploading === void 0 ? [] : _this$state$uploading;
      var newUploadingValue = [];
      var haveUploadingValue = false;

      if (typeof propsUploadingValue === 'undefined') {
        uploadingValue.map(function (item) {
          if (item && item.id === fileId) {
            haveUploadingValue = true;
            newUploadingValue.push(_objectSpread({}, item, {
              progress: event.loaded / event.total * 100
            }));
          } else {
            newUploadingValue.push(item);
          }

          return item;
        });

        if (!haveUploadingValue) {
          newUploadingValue.push({
            id: fileId,
            name: fileTarget.name || '文件正在上传中',
            progress: event.loaded / event.total * 100
          });
        }

        this.setState({
          uploadingValue: newUploadingValue
        });
      }

      if (isFunction(onProgress)) {
        onProgress(event, fileTarget, fileId);
      }
    } // 上传完成回调

  }, {
    key: "handleComplete",
    value: function handleComplete(err, xhr) {
      var resp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var fileTarget = arguments.length > 3 ? arguments[3] : undefined;
      var fileId = arguments.length > 4 ? arguments[4] : undefined;
      var imageIndex = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : -1;
      var _this$props3 = this.props,
          onComplete = _this$props3.onComplete,
          propsUploadingValue = _this$props3.uploadingValue;
      var uploadingValue = this.state.uploadingValue;
      var newUploadingValue = [];

      if (typeof propsUploadingValue === 'undefined') {
        // 删除正在上传数据中的value
        uploadingValue.map(function (item) {
          if (item.id !== fileId) {
            newUploadingValue.push(item);
          }

          return item;
        });
        this.setState({
          uploadingValue: newUploadingValue
        });
      }

      if (isFunction(onComplete)) {
        onComplete(resp, fileTarget, fileId, xhr, imageIndex);
      }
    } // 删除图片

  }, {
    key: "handleDelete",
    value: function handleDelete(event, data, deleteIndex) {
      var _this$props4 = this.props,
          value = _this$props4.value,
          onChange = _this$props4.onChange,
          onDelete = _this$props4.onDelete;
      var result = [];
      var index = -1; // 删除第几张

      if (typeof deleteIndex !== 'undefined') {
        index = parseInt(deleteIndex, 10) || 0;
      } // 剩下的数据


      value.map(function (item, valueIndex) {
        if (valueIndex !== index) {
          result.push((0, _spauiUtils.objectAssign)(item));
        }

        return item;
      });

      if (isFunction(onChange)) {
        onChange(event, result);
      }

      if (isFunction(onDelete)) {
        onDelete(event, data);
      }

      event.stopPropagation();
    } // 获取上传输入框

  }, {
    key: "getInputDOMNode",
    value: function getInputDOMNode() {
      var result = null;

      if (this.uploadRef) {
        result = this.uploadRef.getInputDOMNode();
      }

      return result;
    } // 对外使用可以进行上传

  }, {
    key: "startUpload",
    value: function startUpload() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var headers = arguments.length > 1 ? arguments[1] : undefined;
      var customFiles = arguments.length > 2 ? arguments[2] : undefined;

      if (this.uploadRef && isFunction(this.uploadRef.startUpload)) {
        this.uploadRef.startUpload(data, headers, customFiles);
      }
    } // 对外使用可以进行上传

  }, {
    key: "abort",
    value: function abort() {
      if (this.uploadRef && isFunction(this.uploadRef.abort)) {
        this.uploadRef.abort();
      }
    } // 设置上传功能

  }, {
    key: "setUploader",
    value: function setUploader(children, config) {
      var _this4 = this;

      var _this$props5 = this.props,
          name = _this$props5.name,
          url = _this$props5.url,
          multiple = _this$props5.multiple,
          drag = _this$props5.drag,
          disabled = _this$props5.disabled,
          filter = _this$props5.filter,
          canUpload = _this$props5.canUpload,
          autoUpload = _this$props5.autoUpload,
          _this$props5$dragOver = _this$props5.dragOverClassName,
          dragOverClassName = _this$props5$dragOver === void 0 ? '' : _this$props5$dragOver,
          onUpload = _this$props5.onUpload,
          _this$props5$abortTri = _this$props5.abortTriggerComplete,
          abortTriggerComplete = _this$props5$abortTri === void 0 ? false : _this$props5$abortTri,
          data = _this$props5.data,
          click = _this$props5.click,
          accept = _this$props5.accept,
          onFileChange = _this$props5.onFileChange,
          check = _this$props5.check,
          upload = _this$props5.upload,
          headers = _this$props5.headers,
          _this$props5$FileAPIC = _this$props5.FileAPIConfig,
          FileAPIConfig = _this$props5$FileAPIC === void 0 ? {} : _this$props5$FileAPIC,
          onKeyPress = _this$props5.onKeyPress,
          onKeyUp = _this$props5.onKeyUp,
          onKeyDown = _this$props5.onKeyDown,
          onMouseOver = _this$props5.onMouseOver,
          onMouseOut = _this$props5.onMouseOut,
          onMouseEnter = _this$props5.onMouseEnter,
          onMouseLeave = _this$props5.onMouseLeave,
          onClick = _this$props5.onClick,
          fileId = _this$props5.fileId,
          unmountInactiveInput = _this$props5.unmountInactiveInput,
          setUrl = _this$props5.setUrl,
          uploadPoolSize = _this$props5.uploadPoolSize;
      var props = (0, _spauiUtils.objectAssign)({
        disabled: disabled,
        multiple: multiple,
        drag: drag,
        dragOverClassName: dragOverClassName,
        name: name,
        url: url,
        data: data,
        onUpload: onUpload,
        abortTriggerComplete: abortTriggerComplete,
        filter: filter,
        click: click,
        accept: accept,
        autoUpload: autoUpload,
        canUpload: canUpload,
        onProgress: this.handleProgress,
        onComplete: this.handleComplete,
        onFileChange: onFileChange,
        check: check,
        fileId: fileId,
        headers: headers,
        FileAPIConfig: FileAPIConfig,
        unmountInactiveInput: unmountInactiveInput,
        setUrl: setUrl,
        uploadPoolSize: uploadPoolSize
      }, config);
      var result = null;
      var eventMap = {
        onKeyPress: onKeyPress,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick
      };

      if (disabled) {
        eventMap = {};
      }

      if (upload) {
        result = _react["default"].createElement(_uploader["default"], _extends({}, props, {
          ref: function ref(el) {
            _this4.uploadRef = el;
          },
          instanceId: this.instanceId
        }), children);
      } else {
        result = (0, _react.cloneElement)(children, _objectSpread({}, eventMap, {
          disabled: disabled,
          multiple: multiple,
          drag: !!drag
        }));
      }

      return result;
    } // 添加按钮

  }, {
    key: "haveValueRender",
    // 有数据的显示模块
    value: function haveValueRender() {
      var _this5 = this;

      var _this$props6 = this.props,
          _this$props6$sameValu = _this$props6.sameValueUpdate,
          sameValueUpdate = _this$props6$sameValu === void 0 ? true : _this$props6$sameValu,
          ReactDnD = _this$props6.ReactDnD,
          sortDragItemClassName = _this$props6.sortDragItemClassName,
          sortDragItemStyle = _this$props6.sortDragItemStyle; // 避免其他数据未更改，会一直重复进行组件update，导致不变更的value中会一直请求图片资源等

      if (!sameValueUpdate) {
        return _react["default"].createElement(ValueRenderComponent, {
          value: this.props.value,
          count: this.props.count,
          onChange: this.props.onChange,
          disabled: this.props.disabled,
          drag: this.props.drag,
          ItemAppendComponent: this.props.ItemAppendComponent,
          ImgComponent: this.props.ImgComponent,
          ImgContentComponent: this.props.ImgContentComponent,
          ImgSortComponent: this.props.ImgSortComponent,
          controls: this.props.controls,
          reupload: this.props.reupload,
          MaskContentComponent: this.props.MaskContentComponent,
          required: this.props.required,
          upload: this.props.upload,
          type: this.props.type,
          DisplayComponent: this.props.DisplayComponent,
          useNewUI: this.props.useNewUI,
          addComponentPosition: this.props.addComponentPosition,
          uploadingValue: this.state.uploadingValue,
          setUploader: this.setUploader,
          genAddButton: this.genAddButton,
          handleDelete: this.handleDelete,
          handleComplete: this.handleComplete,
          handleSort: this.handleSort,
          handleHover: this.handleHover,
          ReactDnD: ReactDnD,
          sortDragItemClassName: sortDragItemClassName,
          sortDragItemStyle: sortDragItemStyle
        });
      }

      var _this$props7 = this.props,
          _this$props7$value = _this$props7.value,
          value = _this$props7$value === void 0 ? [] : _this$props7$value,
          count = _this$props7.count,
          onChange = _this$props7.onChange,
          disabled = _this$props7.disabled,
          drag = _this$props7.drag,
          ItemAppendComponent = _this$props7.ItemAppendComponent,
          ImgComponent = _this$props7.ImgComponent,
          ImgContentComponent = _this$props7.ImgContentComponent,
          ImgSortComponent = _this$props7.ImgSortComponent,
          controls = _this$props7.controls,
          reupload = _this$props7.reupload,
          MaskContentComponent = _this$props7.MaskContentComponent,
          required = _this$props7.required,
          upload = _this$props7.upload,
          type = _this$props7.type,
          DisplayComponent = _this$props7.DisplayComponent,
          _this$props7$useNewUI = _this$props7.useNewUI,
          useNewUI = _this$props7$useNewUI === void 0 ? false : _this$props7$useNewUI,
          _this$props7$addCompo = _this$props7.addComponentPosition,
          addComponentPosition = _this$props7$addCompo === void 0 ? '' : _this$props7$addCompo;
      var _this$state$uploading2 = this.state.uploadingValue,
          uploadingValue = _this$state$uploading2 === void 0 ? [] : _this$state$uploading2;
      var imgsClassName = (0, _classnames["default"])('imgs', {
        'imgs-more': count > 1
      });
      var showValue = [];
      var result = [];
      var resultElement = null;
      var valueRenderDom = null;
      var finalDom = null;
      var canAdd = false;
      value.map(function (item) {
        if (item) {
          showValue.push(_objectSpread({}, item));
        }

        return item;
      });
      uploadingValue.map(function (item) {
        if (item) {
          showValue.push(_objectSpread({}, item, {
            status: 'uploading'
          }));
        }

        return item;
      });

      if (count < 2) {
        result = [showValue[0]];
      } else {
        result = showValue;
      } // 有数量限制


      if (result.length > count) {
        if (isFunction(onChange)) {
          onChange({}, result.slice(0, count));
          return false;
        }
      }

      canAdd = !disabled && count > 1 && showValue.length < count;
      resultElement = result.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var canDelete = !(typeof item["delete"] !== 'undefined' && !item["delete"]) && !disabled;
        var canReupload = reupload || false;
        var _item$popover2 = item.popover,
            popover = _item$popover2 === void 0 ? '' : _item$popover2;

        var imageOnComplete = function imageOnComplete(resp, imageIndex, data, fileTarget, fileId, err, xhr) {
          _this5.handleComplete(err, xhr, resp, fileTarget, fileId, imageIndex);
        };

        if (typeof item.reupload !== 'undefined') {
          canReupload = item.reupload || false;
        }

        var child = _react["default"].createElement(ImgComponent, {
          useNewUI: useNewUI,
          onComplete: imageOnComplete,
          useFileAPI: useFileAPI,
          setUploader: _this5.setUploader,
          index: index,
          data: item,
          canDelete: canDelete,
          canReupload: canReupload,
          controls: controls,
          required: required,
          upload: upload,
          drag: drag,
          disabled: disabled,
          onDelete: function onDelete(event) {
            return _this5.handleDelete(event, item, index);
          },
          ItemAppendComponent: ItemAppendComponent,
          ImgContentComponent: ImgContentComponent,
          ImgSortComponent: ImgSortComponent,
          DisplayComponent: DisplayComponent,
          MaskContentComponent: MaskContentComponent,
          type: type,
          onSort: _this5.handleSort,
          onHover: _this5.handleHover,
          ReactDnD: ReactDnD,
          sortDragItemClassName: sortDragItemClassName,
          sortDragItemStyle: sortDragItemStyle
        });

        var itemResult = null;
        var _popover = null;

        if (popover) {
          if (typeof popover === 'string') {
            _popover = _react["default"].createElement(_spauiPopover.PopOver, null, popover);
          } else {
            _popover = popover;
          }

          itemResult = _react["default"].createElement(_spauiPopover.OverlayTrigger, {
            key: index,
            trigger: "hover",
            placement: "top",
            overlay: _popover,
            hideDelayTime: 0
          }, child);
        } else {
          itemResult = (0, _react.cloneElement)(child, {
            key: index
          });
        }

        return itemResult;
      });
      var addButton = canAdd ? this.genAddButton() : null;

      if (useNewUI) {
        // 使用useNewUI 必须有React.Fragment
        if (_react["default"] && _react["default"].Fragment) {
          valueRenderDom = _react["default"].createElement(_react["default"].Fragment, null, addComponentPosition === 'forward' ? addButton : null, resultElement, addComponentPosition !== 'forward' ? addButton : null);
        }
      } else {
        valueRenderDom = _react["default"].createElement("div", {
          className: "uper uped"
        }, _react["default"].createElement("div", {
          className: "imgarea"
        }, _react["default"].createElement("ul", {
          className: imgsClassName
        }, addComponentPosition === 'forward' ? addButton : null, resultElement, addComponentPosition !== 'forward' ? addButton : null)));
      }

      if (canAdd && upload) {
        finalDom = this.setUploader(valueRenderDom, {
          click: false
        });
      } else {
        finalDom = valueRenderDom;
      }

      return finalDom;
    }
  }, {
    key: "needStopPropagationDropEvent",
    value: function needStopPropagationDropEvent() {
      var _this$props8 = this.props,
          drag = _this$props8.drag,
          upload = _this$props8.upload,
          disabled = _this$props8.disabled;
      return drag && upload && !disabled;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props9 = this.props,
          className = _this$props9.className,
          _this$props9$value = _this$props9.value,
          value = _this$props9$value === void 0 ? [] : _this$props9$value,
          drag = _this$props9.drag,
          NoValueComponent = _this$props9.NoValueComponent,
          EmptyComponent = _this$props9.EmptyComponent,
          _this$props9$useNewUI = _this$props9.useNewUI,
          useNewUI = _this$props9$useNewUI === void 0 ? false : _this$props9$useNewUI,
          _this$props9$Addition = _this$props9.AdditionalComponent,
          AdditionalComponent = _this$props9$Addition === void 0 ? null : _this$props9$Addition;
      var _this$state$uploading3 = this.state.uploadingValue,
          uploadingValue = _this$state$uploading3 === void 0 ? [] : _this$state$uploading3;
      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-uploader', className),
        supportAllEvents: true
      }, ImageUploader, this.props), {
        ref: function ref(el) {
          _this6.domRef = el;
        },
        onDrop: this.handleDrop,
        onDragOver: this.handleDragOver
      }), value.length + uploadingValue.length < 1 ? this.setUploader(_react["default"].createElement(NoValueComponent, {
        useFileAPI: useFileAPI,
        useNewUI: useNewUI,
        drag: drag,
        EmptyComponent: EmptyComponent,
        componentProps: this.props
      })) : this.haveValueRender(), (0, _spauiUtils.isReactNode)(AdditionalComponent) ? AdditionalComponent : _react["default"].createElement(AdditionalComponent, _extends({}, this.props, {
        setUploader: this.setUploader
      })));
    }
  }]);

  return ImageUploader;
}(_react.PureComponent);

_defineProperty(ImageUploader, "propTypes", {
  count: _spauiUtils.PropTypes.number,
  value: _spauiUtils.PropTypes.array,
  uploadingValue: _spauiUtils.PropTypes.array,
  name: _spauiUtils.PropTypes.string,
  url: _spauiUtils.PropTypes.string,
  setUrl: _spauiUtils.PropTypes.func,
  data: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.object]),
  headers: _spauiUtils.PropTypes.object,
  uploadPoolSize: _spauiUtils.PropTypes.number,
  disabled: _spauiUtils.PropTypes.bool,
  multiple: _spauiUtils.PropTypes.bool,
  reupload: _spauiUtils.PropTypes.bool,
  required: _spauiUtils.PropTypes.bool,
  upload: _spauiUtils.PropTypes.bool,
  drag: _spauiUtils.PropTypes.bool,
  dragOverClassName: _spauiUtils.PropTypes.string,
  sortDragItemClassName: _spauiUtils.PropTypes.string,
  sortDragItemStyle: _spauiUtils.PropTypes.object,
  sortHoverItemClassName: _spauiUtils.PropTypes.string,
  filter: _spauiUtils.PropTypes.func,
  check: _spauiUtils.PropTypes.func,
  autoUpload: _spauiUtils.PropTypes.bool,
  useNewUI: _spauiUtils.PropTypes.bool,
  onComplete: _spauiUtils.PropTypes.func,
  onChange: _spauiUtils.PropTypes.func,
  onDelete: _spauiUtils.PropTypes.func,
  onFileChange: _spauiUtils.PropTypes.func,
  addComponentPosition: _spauiUtils.PropTypes.string,
  ItemAppendComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  EmptyComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  AddComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  ImgComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  DisplayComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  ImgContentComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  ImgSortComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  NoValueComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  MaskContentComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  AdditionalComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  sameValueUpdate: _spauiUtils.PropTypes.bool // 兼容性开关，2020-06-15添加，若后续没有问题，可直接固定为新逻辑

});

_defineProperty(ImageUploader, "defaultProps", {
  count: 1,
  value: [],
  name: '',
  url: '',
  data: {},
  headers: {},
  disabled: false,
  multiple: false,
  upload: true,
  drag: true,
  dragOverClassName: 'spaui-uploader-drag-over',
  reupload: true,
  required: false,
  autoUpload: true,
  useNewUI: false,
  filter: function filter() {
    return true;
  },
  addComponentPosition: 'backward',
  EmptyComponent: _empty_component["default"],
  AddComponent: _add_component["default"],
  ImgComponent: _img_component["default"],
  ImgContentComponent: _img_content_component["default"],
  ImgSortComponent: _img_sort_component["default"],
  NoValueComponent: _no_value_component["default"],
  MaskContentComponent: _mask_content_component["default"],
  DisplayComponent: _display_component["default"],
  sameValueUpdate: true
});

var _default = ImageUploader;
exports["default"] = _default;